import { ConfigurationContext } from '@providers/ConfigurationProvider';
import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface FavoritesContextType {
  favorites: string[];
  toggleFavorite: (queueId: string) => void;
}

const defaultValue: FavoritesContextType = {
  favorites: [],
  toggleFavorite: () => {} 
};

const QueueFavoritesContext = createContext<FavoritesContextType>(defaultValue);

export const QueueFavoritesProvider = ({ children }: { children: ReactNode }) => {
  const [favorites, setFavorites] = useState<string[]>([]);
  const configuration = useContext(ConfigurationContext)

  useEffect(() => {
    const storedFavorites = (configuration.getValue('queues.favorites') || []) as string[];
    setFavorites(storedFavorites);
  }, []);

  const toggleFavorite = (queueId: string) => {
    const updatedFavorites = favorites.includes(queueId)
      ? favorites.filter(f => f !== queueId)
      : [...favorites, queueId];
      configuration.setValue('queues.favorites', updatedFavorites);
    setFavorites(updatedFavorites);
  };

  return (
    <QueueFavoritesContext.Provider value={{ favorites, toggleFavorite }}>
      {children}
    </QueueFavoritesContext.Provider>
  );
};

export const useFavorites = () => useContext(QueueFavoritesContext);
